module.exports = __webpack_public_path__ + "img/cards.08cf86e8.png";